// import { useState, useMemo, useEffect } from "react";
// import { Box, Button, Checkbox, Typography, TextField, Grid, Paper, IconButton, Stack, Divider, Avatar, Tooltip, CircularProgress, Snackbar, Alert } from '@mui/material';
// import { VscNewFile } from 'react-icons/vsc';
// import { FaUser } from "react-icons/fa";
// import DeleteIcon from '@mui/icons-material/Delete';
// import axios from 'axios';
// import { Link, useNavigate } from 'react-router-dom';
// import { DataGrid } from '@mui/x-data-grid';
// import { useMediaQuery, useTheme } from '@mui/material';
// import { useAuth } from '../../context/AuthContext';
// import PdfViewer from '../../components/PdfViewer';

// const normalizeDate = (v) => typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v.split("-").reverse().join("/") : v;

// const OrderDetail = ({ connectionString, pdfString }) => {
//     const { user, selectedCompany } = useAuth();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;
//     console.log('companyId:', companyId, userId, role)
//     const [activeCard, setActiveCard] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [genQuoteData, setGenQuoteData] = useState([]);
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
//     const isMedium = useMediaQuery(theme.breakpoints.between("sm", "md"));
//     const isMobile = useMediaQuery('(max-width:600px)');
//     const isDesktop = useMediaQuery('(min-width:600px)');
//     const navigate = useNavigate();
//     const [orders, setOrders] = useState([]);
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [snackbarOpen, setSnackbarOpen] = useState(false);
//     const [snackbarMessage, setSnackbarMessage] = useState("");
//     const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//     const [pdfUri, setPdfUri] = useState(null);
//     const [pdfLoading, setPdfLoading] = useState(false);
//     const [pdfError, setPdfError] = useState(null);
//     const [pdfApiUrl, setPdfApiUrl] = useState(null);
//     const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
//     const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

//     const columns = [
//         {
//             field: "SODate", headerName: "Order Date", flex: 0.8, sortable: true,
//             valueFormatter: (params) => {
//                 const v = params.value;
//                 if (typeof v !== "string" || !v.includes("-")) return "-";
//                 const [yyyy, mm, dd] = v.split("-");
//                 return `${dd}/${mm}/${yyyy}`;
//             },
//         },
//         {
//             field: "SONumber", headerName: "Order No.", flex: 1.2,
//             renderCell: (params) => (
//                 <Box onClick={() => navigate(`/main/v3/orderMaster-edit/${params.row.SOId}`)} sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} >
//                     {params.value}
//                 </Box>
//             ),
//         },
//         { field: "PartyPONO", headerName: "Ref No.", flex: 1, },
//         {
//             field: "PartyName", headerName: "Client Details", flex: 2.5,
//             renderCell: (params) => (
//                 <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                     <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}> {params.row.PartyName || '-'} </Typography>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <FaUser color="#FF9800" />
//                         <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
//                     </Stack>
//                     <Typography variant="body2" color="text.secondary"> 📲 {params.row.MobileNo || '-'} </Typography>
//                 </Box>
//             ),
//         },
//         {
//             field: "location", headerName: "Location", flex: 1.5, sortable: true,
//             renderCell: (params) => (
//                 <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                     <Typography variant="body2">{params.row.City || '-'}</Typography>
//                     <Typography variant="caption" sx={{ color: '#666' }}>{params.row.state || '-'}</Typography>
//                 </Box>
//             ),
//         },
//         ...(user?.UserCategory !== "SalesMan"
//             ? [
//                 {
//                     field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right",
//                     valueFormatter: (params) => {
//                         let num = params.value;
//                         if (typeof num === "string") {
//                             num = parseFloat(num);
//                         }
//                         if (typeof num !== "number" || isNaN(num)) return "-";
//                         return `₹${num.toLocaleString("en-IN", {
//                             minimumFractionDigits: 2,
//                             maximumFractionDigits: 2,
//                         })}`;
//                     },
//                 },
//             ]
//             : []),

//         {
//             field: "actions",
//             headerName: "Action",
//             flex: 0.8,
//             sortable: false,
//             align: "right",
//             headerAlign: "right",
//             renderCell: (params) => {
//                 const soId = params.row.SOId ?? params.row.id;
//                 return (
//                     <IconButton
//                         size="small"
//                         color="primary"
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             handleView(soId);
//                         }}
//                     >
//                         <PrintIcon />
//                     </IconButton>
//                 );
//             },
//         },
//     ];

//     if (role !== "User") {
//         columns.push({
//             field: "delete",
//             headerName: "Delete",
//             flex: 0.4,
//             sortable: false,
//             align: "right",
//             headerAlign: "right",
//             renderCell: (params) => {
//                 const isSelected = params.api.isRowSelected(params.id);
//                 return (
//                     <Tooltip
//                         title={
//                             isSelected
//                                 ? "Delete selected orders"
//                                 : "Select row to enable delete"
//                         }
//                     >
//                         <span>
//                             <IconButton
//                                 color="error"
//                                 size="small"
//                                 aria-label={
//                                     isSelected ? "delete" : "select-to-enable-delete"
//                                 }
//                                 disabled={!isSelected}
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     e.preventDefault();
//                                     const selMap = params.api.getSelectedRows();
//                                     const selectedIds = Array.from(selMap.keys()).map(Number);
//                                     handleDelete(selectedIds);
//                                 }}
//                             >
//                                 <DeleteIcon />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             },
//         });
//     }

//     const generatedColumns = [
//         { field: "QoutDate", headerName: "Quotation Date", flex: 0.8, sortable: true, valueFormatter: (params) => normalizeDate(params.value), },
//         { field: "QoutNumber", headerName: "Quotation No.", flex: 1.2, renderCell: (params) => (<Typography>{params.value}</Typography>), },
//         { field: "RefNo", headerName: "Reference No.", flex: 1, },
//         {
//             field: "FirmName", headerName: "Client Name", flex: 2.5,
//             renderCell: (params) => (
//                 <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                     <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}> {params.row.FirmName || '-'} </Typography>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <FaUser color="#FF9800" />
//                         <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
//                     </Stack>
//                     <Typography variant="body2" color="text.secondary"> 📲 {params.row.MobileNo || '-'} </Typography>
//                 </Box>
//             ),
//         },
//         {
//             field: 'location', headerName: 'Location', flex: 1.5, sortable: true,
//             renderCell: (params) => (
//                 <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                     <Typography variant="body2">{params.row.City || '-'}</Typography>
//                     <Typography variant="caption" sx={{ color: '#666' }}>{params.row.state || '-'}</Typography>
//                 </Box>
//             ),
//         },
//         {
//             field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right",
//             valueFormatter: (params) => {
//                 let num = params.value;
//                 if (typeof num === "string") {
//                     num = parseFloat(num);
//                 }
//                 if (typeof num !== "number" || isNaN(num)) return "-";
//                 return `₹${num.toLocaleString("en-IN", {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2,
//                 })}`;
//             },
//         },
//         {
//             field: "actions", headerName: "Action", flex: 0.8, sortable: false, align: "right", headerAlign: "right",
//             renderCell: (params) => (
//                 <Button variant="contained" size="small" onClick={() => {
//                     navigate(`/main/v3/orderMaster-stepper-ref?quotationId=${params.row.QoutId}`);
//                 }} >
//                     Order
//                 </Button>
//             ),
//         },
//     ];

//     const params = {
//         userId,
//         userCategory: role,
//         companyId
//     };

//     const renderPendingCards = () => (
//         <Box>
//             {genQuoteData.map((quote) => (
//                 <Paper key={quote.QoutId} sx={{ p: 2, mb: 2 }}>
//                     <Typography variant="subtitle1">Quotation #{quote.QoutId}</Typography>
//                     <Typography>Quotation No: {quote.quotationNumber}</Typography>
//                     <Typography>Date: {normalizeDate(quote.quotationDate)}</Typography>
//                     <Typography>Client: {quote.clientName}</Typography>
//                     <Typography>Contact: {quote.contactPerson || '-'}</Typography>
//                     <Typography>Mobile: {quote.mobileNo || '-'}</Typography>
//                     <Typography>Location: {quote.city}, {quote.state}</Typography>
//                     <Typography>Total: {Number(quote.subTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
//                     <Button variant="outlined" size="small" onClick={() => navigate(`/main/v3/orderMaster-stepper-ref?quotationId=${quote.QoutId}`)} sx={{ mt: 1 }} > Create Order </Button>
//                 </Paper>
//             ))}
//         </Box>
//     );

//     const api = connectionString;

//     const PDF_API_BASE = pdfString;


//     // const handleView = async (soId) => {
//     //     if (isGeneratingPdf) return;
//     //     if (!soId) return;

//     //     setPdfOverlayVisible(true);
//     //     setIsGeneratingPdf(true);
//     //     setPdfError(null);
//     //     setPdfLoading(true);

//     //     const userIdSafe = userId || 'usr1';
//     //     let formatId = (global && global.selectedFormatId) ? global.selectedFormatId : 'format_1';
//     //     let bookNameToSend = 'Order';
//     //     let bookIdToSend = null;

//     //     // try reading bookName from local orders state (if available)
//     //     try {
//     //         const order = orders.find((o) => Number(o.SOId) === Number(soId));
//     //         if (order?.BookName) bookNameToSend = String(order.BookName).trim();
//     //         if (order?.bookName) bookNameToSend = String(order.bookName).trim();
//     //     } catch (err) { /* ignore */ }

//     //     try {
//     //         const resp = await axios.get(`${api}/api/companies`, { params: { companyId } });
//     //         const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
//     //             Array.isArray(resp?.data) ? resp.data : resp?.data ? [resp.data] : [];

//     //         const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
//     //         const canonical = (s = '') => String(s).replace(/[\s\W_]+/g, '').toLowerCase();

//     //         let found = null;

//     //         // Prefer exact "order" canonical match, fallback to contains 'order' (preserves previous behavior)
//     //         for (const c of comps) {
//     //             if (!c) continue;
//     //             if (!Array.isArray(c.formats)) continue;
//     //             const compMatch = c.CompId && eq(c.CompId, companyId);
//     //             if (!compMatch) continue;

//     //             // exact inside formats
//     //             let exact = null;
//     //             for (const f of c.formats) {
//     //                 const rawBn = String(f.BookName ?? f.bookName ?? '');
//     //                 if (canonical(rawBn) === 'order') {
//     //                     exact = { format: f, company: c };
//     //                     break;
//     //                 }
//     //             }
//     //             if (exact) { found = exact; break; }

//     //             // fallback: first contains 'order'
//     //             for (const f of c.formats) {
//     //                 const rawBn = String(f.BookName ?? f.bookName ?? '');
//     //                 if (canonical(rawBn).includes('order')) {
//     //                     if (!found) found = { format: f, company: c };
//     //                     // don't break — prefer to keep looking for exact matches
//     //                 }
//     //             }
//     //         }

//     //         // fallback root-level bookName on company object (preserve previous root fallback)
//     //         if (!found) {
//     //             for (const c of comps) {
//     //                 const compMatchFlat = c.CompId && eq(c.CompId, companyId);
//     //                 const rootBookName = String(c.BookName ?? c.bookName ?? '');
//     //                 if (compMatchFlat && canonical(rootBookName).includes('order')) {
//     //                     found = { format: c, company: c };
//     //                     break;
//     //                 }
//     //             }
//     //         }

//     //         if (found) {
//     //             const fr = found.format;
//     //             const foundBookId = fr.BookID ?? fr.BookId ?? fr.bookId ?? null;
//     //             if (foundBookId) formatId = `format_${foundBookId}`;
//     //             else if (fr.FormName) formatId = fr.FormName;
//     //             bookNameToSend = fr.BookName ?? bookNameToSend;
//     //             bookIdToSend = foundBookId;
//     //         }

//     //     } catch (err) {
//     //         console.warn('Format detection failed, using defaults', err);
//     //         // fall back to defaults — preserve existing behavior
//     //     }

//     //     // Build API URL (Order)
//     //     let apiUrl =
//     //         `${PDF_API_BASE}/api/pdf/Order/${encodeURIComponent(soId)}` +
//     //         `?userId=${encodeURIComponent(userIdSafe)}` +
//     //         `&format=${encodeURIComponent(formatId)}` +
//     //         `&bookName=${encodeURIComponent(bookNameToSend)}` +
//     //         `&companyId=${encodeURIComponent(companyId ?? '')}`;

//     //     if (bookIdToSend != null) apiUrl += `&bookId=${encodeURIComponent(String(bookIdToSend))}`;

//     //     setPdfApiUrl(apiUrl);

//     //     try {
//     //         const headers = { Accept: 'application/pdf' };
//     //         if (companyId) headers['x-company-id'] = String(companyId);

//     //         const resp = await axios.get(apiUrl, { responseType: 'blob', headers, timeout: 120000 });
//     //         const blob = resp.data;
//     //         if (!blob || blob.size === 0) throw new Error('Empty PDF');

//     //         const blobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));

//     //         // open in new tab (after blob generation) — avoids popup blocker
//     //         const newWin = window.open(blobUrl, '_blank');
//     //         if (newWin) {
//     //             newWin.focus();
//     //             // auto-revoke object URL when tab is closed
//     //             const check = setInterval(() => {
//     //                 if (newWin.closed) {
//     //                     URL.revokeObjectURL(blobUrl);
//     //                     clearInterval(check);
//     //                 }
//     //             }, 1000);
//     //         } else {
//     //             // fallback: show inline viewer
//     //             if (pdfUri) URL.revokeObjectURL(pdfUri);
//     //             setPdfUri(blobUrl);
//     //             setSnackbarMessage('Popup blocked — showing PDF below');
//     //             setSnackbarSeverity('warning');
//     //             setSnackbarOpen(true);
//     //         }
//     //     } catch (err) {
//     //         console.error('PDF Error:', err);
//     //         setPdfError(err?.message || 'Failed to generate PDF');
//     //         setSnackbarMessage('Could not load PDF. Please try again.');
//     //         setSnackbarSeverity('error');
//     //         setSnackbarOpen(true);
//     //     } finally {
//     //         setPdfOverlayVisible(false);
//     //         setIsGeneratingPdf(false);
//     //         setPdfLoading(false);
//     //     }
//     // };

//     const handleView = async (soId) => {
//         if (isGeneratingPdf) return;
//         if (!soId) return;

//         setPdfOverlayVisible(true);
//         setIsGeneratingPdf(true);
//         setPdfError(null);
//         setPdfLoading(true);

//         const userIdSafe = userId || 'usr1';
//         let formatId = (global && global.selectedFormatId) ? global.selectedFormatId : 'format_1';
//         let bookNameToSend = 'Order';
//         let bookIdToSend = null;

//         // === PRESERVE ALL YOUR EXISTING FORMAT DETECTION LOGIC (unchanged) ===
//         try {
//             const order = orders.find((o) => Number(o.SOId) === Number(soId));
//             if (order?.BookName) bookNameToSend = String(order.BookName).trim();
//             if (order?.bookName) bookNameToSend = String(order.bookName).trim();
//         } catch (err) { /* ignore */ }

//         try {
//             const resp = await axios.get(`${api}/api/companies`, { params: { companyId } });
//             const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
//                 Array.isArray(resp?.data) ? resp.data : resp?.data ? [resp.data] : [];
//             const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
//             const canonical = (s = '') => String(s).replace(/[\s\W_]+/g, '').toLowerCase();
//             let found = null;

//             for (const c of comps) {
//                 if (!c) continue;
//                 if (!Array.isArray(c.formats)) continue;
//                 const compMatch = c.CompId && eq(c.CompId, companyId);
//                 if (!compMatch) continue;

//                 let exact = null;
//                 for (const f of c.formats) {
//                     const rawBn = String(f.BookName ?? f.bookName ?? '');
//                     if (canonical(rawBn) === 'order') {
//                         exact = { format: f, company: c };
//                         break;
//                     }
//                 }
//                 if (exact) { found = exact; break; }

//                 for (const f of c.formats) {
//                     const rawBn = String(f.BookName ?? f.bookName ?? '');
//                     if (canonical(rawBn).includes('order')) {
//                         if (!found) found = { format: f, company: c };
//                     }
//                 }
//             }

//             if (!found) {
//                 for (const c of comps) {
//                     const compMatchFlat = c.CompId && eq(c.CompId, companyId);
//                     const rootBookName = String(c.BookName ?? c.bookName ?? '');
//                     if (compMatchFlat && canonical(rootBookName).includes('order')) {
//                         found = { format: c, company: c };
//                         break;
//                     }
//                 }
//             }

//             if (found) {
//                 const fr = found.format;
//                 const foundBookId = fr.BookID ?? fr.BookId ?? fr.bookId ?? null;
//                 if (foundBookId) formatId = `format_${foundBookId}`;
//                 else if (fr.FormName) formatId = fr.FormName;
//                 bookNameToSend = fr.BookName ?? bookNameToSend;
//                 bookIdToSend = foundBookId;
//             }
//         } catch (err) {
//             console.warn('Format detection failed, using defaults', err);
//         }

//         // === NEW: Fetch full order data + company logo from main backend ===
//         let orderData = null;
//         let imageBase64 = null;

//         try {
//             // 1. Fetch company logo
//             try {
//                 const iconRes = await axios.get(`${api}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
//                 if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
//                     imageBase64 = iconRes.data.imageBase64.replace(/^data:image\/[a-z]+;base64,/, ''); // normalize
//                 }
//             } catch (e) {
//                 console.warn("Company logo fetch failed (non-critical)", e);
//             }

//             // 2. Fetch full order master + details
//             const orderResp = await axios.get(`${api}/api/get-order-data/${soId}`, {
//                 params: { companyId },
//                 headers: { "Cache-Control": "no-store" }
//             });

//             const master = orderResp.data.master;
//             const details = orderResp.data.details || [];

//             if (!master) {
//                 throw new Error("No master order data returned");
//             }

//             // 3. Build items array
//             const items = details.map(d => {
//                 const qty = Number(d.Qty) || 0;
//                 const rate = Number(d.Rate) || 0;
//                 const disc = Number(d.Disc) || 0;
//                 const amount = qty * rate * (1 - disc / 100);
//                 return {
//                     ItemCode: d.itemCode || "",
//                     productImage: d.productImage || "",
//                     hsnCode: d.HSNNo || "",
//                     description: d.productDescription || "",
//                     brand: d.brand || "",
//                     qty: d.Qty || "",
//                     rate: d.Rate || "",
//                     Unit: d.Unit || "",
//                     discount: d.Disc || "",
//                     cgst: parseFloat(d.CGST) || 0,
//                     sgst: parseFloat(d.SGST) || 0,
//                     igst: parseFloat(d.IGST) || 0,
//                     amount: amount,
//                     Group: d.Group || "Ungrouped"
//                 };
//             });

//             // 4. Build final pdfData object
//             orderData = {
//                 companyId: companyId,
//                 companyName: master.FirmName || "",
//                 address: master.Address || "",
//                 phone: master.MobileNo || "",
//                 gstNo: master.GSTNo || "",
//                 invoiceNo: master.SONumber || "",
//                 referrenceNo: master.PartyPONO || master.RefNo || "",
//                 date: master.SODate ? normalizeDate(master.SODate) : "",
//                 transport: master.Transporter || "SELF",
//                 challanNo: master.lrNumber || "",
//                 poNo: master.Project || "",
//                 state: master.state || "",
//                 stateCode: master.StateCode || "",
//                 LrNo: master.lrNumber || "",
//                 vehNo: master.vehicleNumber || "",
//                 LrDate: master.lrDate ? normalizeDate(master.lrDate) : "",
//                 shipToGstNumber: master.shipToGstNumber || "",
//                 shipToState: master.state || "",
//                 items,
//                 toEmail: master.EmailId || "",
//                 totalAmount: master.grandTotal || 0,
//                 mobileNo: master.MobileNo || "",
//                 basicAmount: Number(master.BasicAmt) || 0,
//                 CGSTAmt: Number(master.CGSTAmt) || 0,
//                 SGSTAmt: Number(master.SGSTAmt) || 0,
//                 IGSTAmt: Number(master.IGSTAmt) || 0,
//                 RoundOff: Number(master.RoundOff) || 0,
//                 BillAmt: Number(master.BillAmt) || 0,
//                 clientState: master.clientState || "",
//                 clientStateCode: master.clientStateCode || "",
//                 imageBase64: imageBase64 || null
//             };

//         } catch (err) {
//             console.error("Failed to load order data or logo", err);
//             setPdfError("Failed to load order details");
//             setSnackbarMessage("Could not load order data for PDF generation.");
//             setSnackbarSeverity("error");
//             setSnackbarOpen(true);
//             setPdfOverlayVisible(false);
//             setIsGeneratingPdf(false);
//             setPdfLoading(false);
//             return;
//         }

//         // === POST full data to PDF backend (same as QuotationDetail) ===
//         const pdfPayload = {
//             docId: soId,
//             userId: userIdSafe,
//             formatId,
//             bookName: bookNameToSend,
//             ...(bookIdToSend !== null && { bookId: bookIdToSend }),
//             data: orderData,
//             company: {
//                 CompanyName: selectedCompany?.CompanyName || selectedCompany?.companyName || "",
//                 Address: selectedCompany?.Address || selectedCompany?.address || "",
//                 MobileNo: selectedCompany?.MobileNo || selectedCompany?.mobileNo || "",
//                 GSTNo: selectedCompany?.GSTNo || selectedCompany?.gstNo || "",
//                 imageBase64: imageBase64 || null
//             }
//         };

//         try {
//             const pdfResp = await axios.post(
//                 `${PDF_API_BASE}/api/pdf/Order/${encodeURIComponent(soId)}`,
//                 pdfPayload,
//                 { responseType: "blob", timeout: 180000 }
//             );

//             const blob = pdfResp.data;
//             if (!blob || blob.size === 0) throw new Error("Empty PDF received");

//             const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

//             const newWin = window.open(blobUrl, "_blank");
//             if (newWin) {
//                 newWin.focus();
//                 const check = setInterval(() => {
//                     if (newWin.closed) {
//                         URL.revokeObjectURL(blobUrl);
//                         clearInterval(check);
//                     }
//                 }, 1000);
//             } else {
//                 if (pdfUri) URL.revokeObjectURL(pdfUri);
//                 setPdfUri(blobUrl);
//                 setSnackbarMessage("Popup blocked — showing PDF below");
//                 setSnackbarSeverity("warning");
//                 setSnackbarOpen(true);
//             }
//         } catch (err) {
//             console.error("PDF Generation Failed:", err);
//             setPdfError(err?.message || "Failed to generate PDF");
//             setSnackbarMessage("Could not generate PDF. Please try again.");
//             setSnackbarSeverity("error");
//             setSnackbarOpen(true);
//         } finally {
//             setPdfOverlayVisible(false);
//             setIsGeneratingPdf(false);
//             setPdfLoading(false);
//         }
//     };

//     useEffect(() => { fetchGenQuote(); }, []);

//     useEffect(() => {
//         (async () => {
//             setLoading(true);
//             try {
//                 const res = await axios.get(`${api}/api/orders`, {
//                     params,
//                     headers: {
//                         'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                     }
//                 });
//                 console.log(res.data);
//                 setOrders(res.data || []);
//             } catch (err) {
//                 console.error('Failed to fetch orders', err);
//                 if (err.response && err.response.status === 304) {
//                     setOrders([]);
//                 }
//             } finally {
//                 setLoading(false);
//             }
//         })();
//     }, []);

//     // --- move/replace fetchGenQuote so it's defined BEFORE the useEffect that calls it ---
//     const fetchGenQuote = async () => {
//         setLoading(true);
//         try {
//             const { data } = await axios.get(`${api}/api/quotationmaster`, {
//                 params: {
//                     ...params,
//                     mode: "ref"
//                 },
//                 headers: {
//                     'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                 }
//             });
//             console.log('Raw genQuote API data:', data);

//             const transformedData = data.map(r => ({
//                 ...r,
//                 id: Number(r.QoutId),            // <- explicit id for DataGrid
//                 QoutId: Number(r.QoutId),
//                 BillAmt: parseFloat(r.BillAmt) || 0,
//                 BasicAmt: parseFloat(r.BasicAmt) || 0,
//                 DiscAmt: parseFloat(r.DiscAmt) || 0,
//                 TaxableAmt: parseFloat(r.TaxableAmt) || 0,
//                 RoundOff: parseFloat(r.RoundOff) || 0
//             }));
//             console.log('Transformed genQuoteData:', transformedData);
//             setGenQuoteData(transformedData);
//         } catch (err) {
//             if (err.response && err.response.status === 304) {
//                 setGenQuoteData([]);
//             } else {
//                 console.error('Error fetching quotation data:', err);
//                 setSnackbarMessage("Failed to fetch quotation data.");
//                 setSnackbarSeverity("error");
//                 setSnackbarOpen(true);
//                 setTimeout(() => { setSnackbarOpen(false); }, 3000);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleExport = async () => {
//         try {
//             const response = await axios.get(`${api}/api/inqdetails/search?mode=export`, { responseType: 'blob' });
//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'InquiryExport.xlsx');
//             document.body.appendChild(link);
//             link.click();
//         } catch (error) {
//             console.error('Error exporting:', error);
//             setSnackbarMessage("Failed to export data.");
//             setSnackbarSeverity("error");
//             setSnackbarOpen(true);
//             setTimeout(() => {
//                 setSnackbarOpen(false);
//             }, 3000);
//         }
//     };

//     const handleDelete = async (ids) => {
//         if (ids.length === 0) {
//             setSnackbarMessage("No orders selected for deletion.");
//             setSnackbarSeverity("warning");
//             setSnackbarOpen(true);
//             setTimeout(() => {
//                 setSnackbarOpen(false);
//             }, 3000);
//             return;
//         }

//         if (!window.confirm(`Are you sure you want to delete ${ids.length} order(s)?`)) return;

//         console.log("Deleting IDs:", ids);

//         try {
//             const payload = { objAryId: ids, companyId };
//             const { data } = await axios.post(`${api}/api/delete-orders`, payload);

//             console.log("Delete API response:", data);

//             const referencedIds = data.referencedIds || [];
//             const hasReferences = referencedIds.length > 0;
//             const totalDeleted = (data.deletedOrders || 0) + (data.deletedOrderDetails || 0);

//             if (totalDeleted > 0) {
//                 setOrders(prev => prev.filter(row => !ids.includes(Number(row.SOId)) || referencedIds.includes(Number(row.SOId))));
//                 setSelectionModel(prev => prev.filter(id => referencedIds.includes(id)));
//                 setSnackbarMessage(`Deleted ${data.deletedOrders || 0} orders and ${data.deletedOrderDetails || 0} details.`);
//                 setSnackbarSeverity("success");
//                 setSnackbarOpen(true);
//                 setTimeout(() => {
//                     setSnackbarOpen(false);
//                 }, 3000);
//             }

//             if (hasReferences) {
//                 setSnackbarMessage(`The following ID(s) have references and cannot be deleted: ${referencedIds.join(', ')}`);
//                 setSnackbarSeverity("warning");
//                 setSnackbarOpen(true);
//                 setTimeout(() => {
//                     setSnackbarOpen(false);
//                 }, 3000);
//             } else if (totalDeleted === 0) {
//                 setSnackbarMessage("No orders deleted, possibly due to references.");
//                 setSnackbarSeverity("warning");
//                 setSnackbarOpen(true);
//                 setTimeout(() => {
//                     setSnackbarOpen(false);
//                 }, 3000);
//             }
//         } catch (err) {
//             console.error('Error deleting orders:', err);
//             setSnackbarMessage("Failed to delete one or more orders.");
//             setSnackbarSeverity("error");
//             setSnackbarOpen(true);
//             setTimeout(() => {
//                 setSnackbarOpen(false);
//             }, 3000);
//         }
//     };

//     const handleSnackbarClose = (event, reason) => {
//         if (reason === 'clickaway') {
//             return;
//         }
//         setSnackbarOpen(false);
//     };

//     return (
//         <Box p={2}>
//             <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <IconButton component={Link} to="/main/v3/orderMaster-stepper" size="small" sx={{ color: 'orange' }} aria-label="New-Order"> <VscNewFile size={20} /> </IconButton>
//                     <Typography variant="h5" sx={{ mb: 1, fontWeight: "bold" }}> New Order </Typography>
//                 </Box>
//                 <Button variant="contained" size="small"
//                     color="primary"
//                     onClick={() => {
//                         if (activeCard === "get") {
//                             setActiveCard(null);
//                         } else {
//                             fetchGenQuote();
//                             setActiveCard("get");
//                         }
//                     }}
//                 >
//                     {activeCard === "get" ? 'Hide' : 'Show'}
//                 </Button>
//             </Grid>

//             {loading ? (
//                 <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
//                     <CircularProgress />
//                 </Box>
//             ) : (
//                 <>
//                     {activeCard === "get" && (
//                         <>
//                             {isDesktop ? (
//                                 <Paper elevation={2} sx={{ borderRadius: 3, p: 2, overflow: 'hidden', mb: 1 }}>
//                                     <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
//                                         <Typography variant='h6' fontWeight={600}>Quotation List</Typography>
//                                     </Box>
//                                     <DataGrid
//                                         autoHeight
//                                         getRowHeight={() => 'auto'}
//                                         rows={(genQuoteData || []).map(r => ({ ...r, id: r.id ?? Number(r.QoutId) }))}
//                                         columns={generatedColumns}
//                                         getRowId={(row) => row.id ?? Number(row.QoutId)}
//                                         pageSize={5}
//                                         rowsPerPageOptions={[5, 10, 25]}
//                                         pagination
//                                         disableRowSelectionOnClick
//                                         /* ---------- reliable "auto" row height implementation ---------- */
//                                         // getRowHeight={(params) => {
//                                         //     // base row height (for one line)
//                                         //     const base = 56;
//                                         //     console.log(params)
//                                         //     // approximate characters per line — tweak to match your column widths / font
//                                         //     const charsPerLine = isDesktop ? 60 : 28;

//                                         //     // choose which fields may wrap and contribute to height
//                                         //     const text = `${params.model.FirmName || ''} ${params.model.ContactPerson || ''} ${params.model.Remark || ''}`;

//                                         //     // estimate lines (at least 1)
//                                         //     const estimatedLines = Math.max(1, Math.ceil((text.length || 0) / charsPerLine));

//                                         //     // pixel height per extra line (tweak if your font/spacing differs)
//                                         //     const perLinePx = 18;

//                                         //     // return numeric height (px)
//                                         //     return base + (estimatedLines - 1) * perLinePx;
//                                         // }}

//                                         slots={{
//                                             noRowsOverlay: () => (
//                                                 <Box sx={{ p: 2, textAlign: 'center' }}>
//                                                     <Typography>No quotation records found.</Typography>
//                                                 </Box>
//                                             ),
//                                         }}
//                                         sx={{
//                                             '& .MuiDataGrid-columnHeaders': { backgroundColor: '#b55f16', color: '#FFFFFF', fontWeight: 'bold' },
//                                             '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-columnHeaderTitleContainer': { color: '#FFFFFF' },
//                                             '& .MuiDataGrid-columnHeader .MuiSvgIcon-root': { color: '#FFFFFF !important', opacity: 1 },
//                                             '& .MuiDataGrid-columnHeader .MuiIconButton-root': { color: '#FFFFFF !important', opacity: 1 },
//                                             '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': { color: '#FFFFFF !important', opacity: 1 },
//                                             '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg path': { fill: '#FFFFFF !important', stroke: '#FFFFFF !important', color: '#FFFFFF !important', opacity: 1 },
//                                             '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon svg path, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon svg path': { fill: '#FFFFFF !important', stroke: '#FFFFFF !important', opacity: 1 },
//                                             '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                             '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#ecf4fc' },
//                                             '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none' },
//                                         }}
//                                     />
//                                 </Paper>
//                             ) : (
//                                 renderPendingCards()
//                             )}
//                         </>
//                     )}
//                 </>
//             )}

//             <Paper sx={{ borderRadius: 1, mt: 1, maxWidth: `calc(100%)` }}>
//                 {loading ? (
//                     <Box textAlign="center" mt={4}>
//                         <CircularProgress />
//                     </Box>
//                 ) : (
//                     <Paper elevation={2} sx={{ borderRadius: 3, p: 2, overflow: 'hidden' }}>
//                         <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
//                             <Typography variant='h6' fontWeight={600}>Order List</Typography>
//                         </Box>
//                         <DataGrid
//                             rows={orders}
//                             getRowHeight={() => 'auto'}
//                             columns={columns}
//                             getRowId={(row) => row.SOId}
//                             pageSizeOptions={[25, 50, 100]}
//                             checkboxSelection={role !== "User"}
//                             rowSelectionModel={selectionModel}
//                             onRowSelectionModelChange={(newSel) => setSelectionModel(newSel.map(Number))}
//                             disableRowSelectionOnClick
//                             autoHeight
//                             slots={{
//                                 noRowsOverlay: () => (
//                                     <Box sx={{ p: 2, textAlign: 'center' }}>
//                                         <Typography>No order records found.</Typography>
//                                     </Box>
//                                 ),
//                             }}
//                             sx={{
//                                 '& .MuiDataGrid-columnHeaders': { backgroundColor: '#165bb5', color: '#FFFFFF', fontWeight: 'bold' },
//                                 '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-columnHeaderTitleContainer': { color: '#FFFFFF' },
//                                 '& .MuiDataGrid-columnHeader .MuiSvgIcon-root': { color: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-columnHeader .MuiIconButton-root': { color: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': { color: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg path': { fill: '#FFFFFF !important', stroke: '#FFFFFF !important', color: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon svg path, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon svg path': { fill: '#FFFFFF !important', stroke: '#FFFFFF !important', opacity: 1 },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#ecf4fc' },
//                                 '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none' },
//                             }}
//                         />
//                     </Paper>
//                 )}

//                 {pdfError && (
//                     <Box sx={{ mt: 2, mx: 'auto', width: '97%' }}>
//                         <Alert severity="error">PDF Error: {pdfError}</Alert>
//                     </Box>
//                 )}
//                 {pdfLoading && (
//                     <Box sx={{ mt: 2, mx: 'auto', width: '97%', display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <CircularProgress size={18} /> <Typography>Preparing PDF...</Typography>
//                     </Box>
//                 )}
//                 {pdfUri && (
//                     <Box sx={{ mt: 2, mx: 'auto', width: '97%' }}>
//                         <PdfViewer uri={pdfUri} remoteFallbackUrl={pdfApiUrl} />
//                     </Box>
//                 )}

//                 {pdfOverlayVisible && (
//                     <Box sx={{
//                         position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
//                         backgroundColor: 'rgba(0,0,0,0.92)', zIndex: 9999,
//                         display: 'flex', justifyContent: 'center', alignItems: 'center',
//                         backdropFilter: 'blur(2px)'
//                     }}>
//                         <Box sx={{ textAlign: 'center', backgroundColor: '#111', padding: '40px 60px', borderRadius: '20px' }}>
//                             <CircularProgress size={60} thickness={4} sx={{ color: '#fff' }} />
//                             <Typography variant="h6" sx={{ color: '#fff', mt: 3, fontWeight: 600 }}>
//                                 Generating Order PDF…
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: '#aaa', mt: 1 }}>Please wait</Typography>
//                         </Box>
//                     </Box>
//                 )}

//             </Paper>
//             <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
//                 <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }} >
//                     {snackbarMessage}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// };

// export default OrderDetail;














import { useState, useMemo, useEffect, useRef, useCallback } from "react";
import { Box, Button, Checkbox, Card, CardContent, Typography, TextField, Grid, Paper, IconButton, Stack, Avatar, Tooltip, CircularProgress, Snackbar, Alert, InputAdornment, Divider, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Autocomplete, RadioGroup, Radio, FormControlLabel, LinearProgress } from '@mui/material';
import { VscNewFile } from 'react-icons/vsc';
import { FaUser } from "react-icons/fa";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { useMediaQuery, useTheme } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import SearchIcon from '@mui/icons-material/Search';
import PdfViewer from '../../components/PdfViewer';
import DescriptionIcon from '@mui/icons-material/Description';
import LinkIcon from '@mui/icons-material/Link';
import PersonIcon from '@mui/icons-material/Person';
import PrintIcon from '@mui/icons-material/Print';
import { formatRows } from "../../utils/formatRows";
import NoDataComponent from "../../components/NoDataComponent";
import CustomNoDataOverlay from "../../components/CustomNoDataOverlay";
import { showMessageFromRoute } from "../../utils/showMessageFromRoute";
import CenterLoader from "../../components/CenterLoader";
import { APPBAR_HEIGHT } from "../../utils/theme";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import * as XLSX from 'xlsx';
import LoadingOverlay from '../../components/LoadingOverlay';
import SkeletonLoader from '../../components/SkeletonLoader';
import { motion } from 'framer-motion';

const getFinancialYearRange = (now = new Date()) => {
    const month = now.getMonth();
    const startYear = month >= 3 ? now.getFullYear() : now.getFullYear() - 1;
    return { from: `${startYear}-04-01`, to: `${startYear + 1}-03-31` };
};

const normalizeDate = (v) =>
    typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)
        ? v.split("-").reverse().join("/")
        : v;

// Helper for avatar color
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

function getInitials(name) {
    if (!name) return 'O';
    return name.trim().charAt(0).toUpperCase();
}

const OrderDetail = ({ connectionString, pdfString }) => {
    const PDF_API_BASE = pdfString;
    const { user, selectedCompany } = useAuth();
    const api = connectionString;
    const navigate = useNavigate();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));

    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const role = user?.UserCategory;
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const [activeCard, setActiveCard] = useState(null); // "get" when showing quotations
    const [loading, setLoading] = useState(false);
    const [orders, setOrders] = useState([]);
    const [genQuoteData, setGenQuoteData] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [selectionModel, setSelectionModel] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [pdfUri, setPdfUri] = useState(null);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfError, setPdfError] = useState(null);
    const [pdfApiUrl, setPdfApiUrl] = useState(null);
    const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // Filter popup states
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const [filterPopupMode, setFilterPopupMode] = useState('datewise');
    const [filterPopupFromDate, setFilterPopupFromDate] = useState('');
    const [filterPopupToDate, setFilterPopupToDate] = useState('');
    const [filterPopupFirms, setFilterPopupFirms] = useState([]);
    const [firmOptions, setFirmOptions] = useState([]);
    const [firmAllOptions, setFirmAllOptions] = useState([]);
    const [firmInputValue, setFirmInputValue] = useState('');
    const [firmLoading, setFirmLoading] = useState(false);
    const [filterPopupSnapshot, setFilterPopupSnapshot] = useState(null);
    const [exportExcelEnabled, setExportExcelEnabled] = useState(false);
    const [masterReportData, setMasterReportData] = useState([]);
    const [detailsReportData, setDetailsReportData] = useState([]);
    const [reportLoading, setReportLoading] = useState(false);

    const newWinRef = useRef(null);

    const params = { userId, userCategory: role, companyId };

    console.log("orders", orders)
    const location = useLocation()
    useEffect(() => {
        showMessageFromRoute(location, setSnackbar);
    }, [location.state]);

    // Columns for Orders (main list) — your original design preserved
    const orderColumns = useMemo(() => {
        const cols = [
            {
                field: "SODate", headerName: "Order Date", flex: 0.8, sortable: true, filterable: true,
                valueGetter: (value) => {
                    if (typeof value !== "string" || !value.includes("-")) return "-";
                    const [yyyy, mm, dd] = value.split("T")[0].split("-");
                    return `${dd}/${mm}/${yyyy}`;
                },
            },
            {
                field: "SONumber", headerName: "Order No.", flex: 1.2,
                renderCell: (params) => (
                    <Box onClick={() => navigate(`/main/v3/orderMaster-edit/${params.row.SOId}`)} sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} >
                        {params.value}
                    </Box>
                ),
            },
            { field: "PartyPONO", headerName: "Ref No.", flex: 1, },
            {
                field: "PartyName", headerName: "FirmName", flex: 2.5,
                renderCell: (params) => (
                    <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}> {params.row.PartyName || '-'} </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <FaUser color="#FF9800" />
                            <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
                        </Stack>
                        <Typography variant="body2" color="text.secondary"> 📲 {params.row.MobileNo || '-'} </Typography>
                    </Box>
                ),
            },
            {
                field: "location", headerName: "Location", flex: 1.5, sortable: true, filterable: true,
                valueGetter: (value, row) => [row.City, row.state].filter(Boolean).join(", "),
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="body2">{params.row.City || '-'}</Typography>
                        <Typography variant="caption" sx={{ color: '#666' }}>{params.row.state || '-'}</Typography>
                    </Box>
                ),
            },
            ...(user?.UserCategory !== "SalesMan"
                ? [
                    {
                        field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right",
                        valueFormatter: (params) => {
                            let num = params;
                            if (typeof num === "string") {
                                num = parseFloat(num);
                            }
                            if (typeof num !== "number" || isNaN(num)) return "-";
                            return `₹${num.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}`;
                        },
                    },
                ]
                : []),
            {
                field: "actions",
                headerName: "Action",
                flex: 0.8,
                sortable: false,
                filterable: false,
                align: "right",
                headerAlign: "right",
                renderCell: (params) => {
                    const soId = params.row.SOId ?? params.row.id;
                    return (
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleView(soId);
                            }}
                        >
                            <PrintIcon />
                        </IconButton>
                    );
                },
            },
        ];

        if (role !== "User") {
            cols.push({
                field: "delete",
                headerName: "Delete",
                flex: 0.4,
                sortable: false,
                filterable: false,
                align: "right",
                headerAlign: "right",
                renderCell: (params) => {
                    const isSelected = selectionModel.includes(params.row.SOId);
                    return (
                        <Tooltip title="Delete selected order(s)">
                            <span>
                                <IconButton color="error" onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete();
                                }} disabled={!isSelected} size="small">
                                    <DeleteIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    );
                },
            });
        }
        return cols;
    }, [selectionModel, role]);

    // Columns for Quotations (when "Show" is clicked) — your original design preserved
    const quotationColumns = useMemo(() => [
        { field: "QoutDate", headerName: "Quotation Date", flex: 0.8, sortable: true, valueGetter: (value) => normalizeDate(value), valueFormatter: (params) => normalizeDate(params), filterable: true, },
        { field: "QoutNumber", headerName: "Quotation No.", flex: 1.2, renderCell: (params) => (<Typography>{params.value}</Typography>), },
        // { field: "RefNo", headerName: "Reference No.", flex: 1, },
        {
            field: "FirmName", headerName: "FirmName", flex: 2.5,
            renderCell: (params) => (
                <Box sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}> {params.row.FirmName || '-'} </Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <FaUser color="#FF9800" />
                        <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary"> 📲 {params.row.MobileNo || '-'} </Typography>
                </Box>
            ),
        },
        {
            field: 'location', headerName: 'Location', flex: 1.5, sortable: true, filterable: true,
            valueGetter: (value, row) => [row.City, row.state].filter(Boolean).join(', '),
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2">{params.row.City || '-'}</Typography>
                    <Typography variant="caption" sx={{ color: '#666' }}>{params.row.state || '-'}</Typography>
                </Box>
            ),
        },
        {
            field: "BillAmt", headerName: "Total Amt", flex: 1, align: "right", headerAlign: "right",
            valueFormatter: (params) => {
                let num = params;
                if (typeof num === "string") {
                    num = parseFloat(num);
                }
                if (typeof num !== "number" || isNaN(num)) return "-";
                return `₹${num.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}`;
            },
        },
        {
            field: "actions", headerName: "Action", flex: 0.8, sortable: false, align: "right", headerAlign: "right", filterable: false,
            renderCell: (params) => (
                <Button variant="contained" size="small" onClick={() => {
                    navigate(`/main/v3/orderMaster-stepper-ref?quotationId=${params.row.QoutId}`);
                }} >
                    Order
                </Button>
            ),
        },
    ], []);

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${api}/api/orders`, { params, headers: { 'Cache-Control': 'no-store' } });
            setOrders(formatRows(res.data || []));
        } catch (err) {
            console.error('Failed to fetch orders', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchGenQuote = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get(`${api}/api/quotationmaster`, {
                params: { ...params, mode: "ref" },
                headers: { 'Cache-Control': 'no-store' }
            });
            const transformed = data.map(r => ({
                ...r,
                id: Number(r.QoutId),
                BillAmt: parseFloat(r.BillAmt) || 0,
            }));
            setGenQuoteData(formatRows(transformed));
        } catch (err) {
            console.error('Error fetching quotations:', err);
            setGenQuoteData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleQuotations = () => {
        if (activeCard === "get") {
            setActiveCard(null);
        } else {
            setActiveCard("get");
            fetchGenQuote();
        }
    };

    const handleDelete = async () => {
        if (selectionModel.length === 0) {
            setSnackbarMessage("No orders selected for deletion.");
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
            return;
        }
        setOpenDeleteDialog(true);
        console.log("Deleting IDs:", selectionModel);

    };

    const confirmDelete = async () => {
        if (deleting) return;
        setDeleting(true);

        try {
            const payload = { objAryId: selectionModel, companyId };
            const { data } = await axios.post(`${api}/api/delete-orders`, payload);
            // const referencedIds = data.referencedIds || [];
            // const blockedIds = data.blockedIds || [] ;
            // const deletedCount = (data.deletedOrders || 0) + (data.deletedOrderDetails || 0);
            const blockedIds = (data.blockedIds || [])
            const deletedOrders = data.deletedOrders || 0;
            const deletedDetails = data.deletedOrderDetails || 0;

            // console.log(blockedIds , orders.SOId)

            // const blockedOrderNumbers = orders
            //     .filter(order => blockedIds.map(Number).includes(order.SOId))
            //     .map(order => order.SONumber);

            // console.log("blockedOrderNumbers", blockedOrderNumbers)

            // if (deletedCount > 0) {
            //     setOrders(prev => prev.filter(row => !selectionModel.includes(row.SOId) || referencedIds.includes(row.SOId)));
            //     setSelectionModel(prev => prev.filter(id => referencedIds.includes(id)));
            // }

            if (deletedOrders > 0) {
                setOrders(prev =>
                    prev.filter(row => !selectionModel.includes(row.SOId) || blockedIds.includes(row.SOId))
                );

                setSelectionModel(blockedIds);
            }

            if (deletedOrders > 0) {
                setSnackbarMessage("Deleted Successfully.");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
            }

            if (blockedIds.length > 0 && deletedOrders <= 0) {
                setSnackbarMessage("Cannot delete the selected item(s) because they are referenced in other records.");
                setSnackbarSeverity("warning");
                setSnackbarOpen(true);

            }
        } catch (err) {
            console.error('Error deleting orders:', err);
            setSnackbarMessage("Delete failed due to an unexpected error.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setDeleting(false);
            setOpenDeleteDialog(false);
        }
    };

    const handleView = async (soId) => {
        if (isGeneratingPdf || !soId) return;
        setPdfOverlayVisible(true);
        setIsGeneratingPdf(true);
        setPdfLoading(true);

        const userIdSafe = userId || 'usr1';
        let formatId = 'format_1';
        let bookNameToSend = 'Order';
        let bookIdToSend = null;

        try {
            const order = orders.find(o => Number(o.SOId) === Number(soId));
            if (order?.BookName) bookNameToSend = String(order.BookName).trim();
            if (order?.bookName) bookNameToSend = String(order.bookName).trim();
        } catch (e) { /* ignore */ }

        let matchedFormat = null;
        try {
            // ✅ Add cache-buster to get fresh data
            const cacheBreaker = new Date().getTime();
            const resp = await axios.get(`${api}/api/companies`, { params: { companyId, t: cacheBreaker } });
            const comps = Array.isArray(resp?.data?.companies) ? resp.data.companies :
                Array.isArray(resp?.data) ? resp.data : resp?.data ? [resp.data] : [];

            let found = null;
            const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();
            const canonical = (s = '') => String(s).replace(/[\s\W_]+/g, '').toLowerCase();

            for (const c of comps) {
                if (!c || !Array.isArray(c.formats)) continue;
                if (!c.CompId || !eq(c.CompId, companyId)) continue;

                let exact = null;
                for (const f of c.formats) {
                    if (canonical(f.BookName ?? f.bookName ?? '') === 'order') {
                        exact = { format: f, company: c };
                        break;
                    }
                }
                if (exact) { found = exact; break; }

                for (const f of c.formats) {
                    if (canonical(f.BookName ?? f.bookName ?? '').includes('order')) {
                        if (!found) found = { format: f, company: c };
                    }
                }
            }

            if (!found) {
                for (const c of comps) {
                    if (c.CompId && eq(c.CompId, companyId) && canonical(c.BookName ?? c.bookName ?? '').includes('order')) {
                        found = { format: c, company: c };
                        break;
                    }
                }
            }

            if (found) {
                const fr = found.format;
                const bid = fr.BookID ?? fr.BookId ?? fr.bookId ?? null;
                if (bid) formatId = `format_${bid}`;
                else if (fr.FormName) formatId = fr.FormName;
                bookNameToSend = fr.BookName ?? bookNameToSend;
                bookIdToSend = bid;
                // ✅ Store matched format for Signature checking (fresh from API)
                matchedFormat = fr;
            }
        } catch (err) {
            console.warn('Format detection failed', err);
        }

        let imageBase64 = null;
        let signatureBase64 = null;
        try {
            const iconRes = await axios.get(`${api}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
            if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
                imageBase64 = iconRes.data.imageBase64.replace(/^data:image\/[a-z]+;base64,/, '');
            }
            if (iconRes?.data?.signatureBase64) {
                signatureBase64 = iconRes.data.signatureBase64;
            }
        } catch (e) { console.warn("Logo fetch failed", e); }
        // ✅ Use matched format's Signature (fresh from API, not cached context)
        if (!matchedFormat?.Signature) signatureBase64 = null;

        try {
            const orderResp = await axios.get(`${api}/api/get-order-data/${soId}`, { params: { companyId } });
            const master = orderResp.data.master;
            const details = orderResp.data.details || [];
            const companyDetails = orderResp.data.company || null;
            const termsAndConditions = orderResp.data.termsAndConditions || null;
            const additionalChargeItems = orderResp.data.additionalChargeItems || [];

            console.log(orderResp)

            if (!master) throw new Error("No master data");

            const termsText = Array.isArray(termsAndConditions) && termsAndConditions.length > 0
                ? termsAndConditions
                    .sort((a, b) => a.SrNo - b.SrNo)
                    .map(t => `# ${t.TermsDescription}`)
                    .join('\n')
                : null;

            const items = details.map(d => {
                const qty = Number(d.Qty) || 0;
                const rate = Number(d.Rate) || 0;
                const disc = Number(d.Disc) || 0;
                const amount = qty * rate * (1 - disc / 100);
                return {
                    ItemCode: d.itemCode || "",
                    productImage: d.productImage || "",
                    Remark: d.Remark || "",
                    hsnCode: d.HSNNo || "",
                    description: d.productDescription || "",
                    brand: d.brand || "",
                    qty: d.Qty || "",
                    rate: d.Rate || "",
                    Unit: d.Unit || "",
                    discount: d.Disc || "",
                    cgst: parseFloat(d.CGST) || 0,
                    sgst: parseFloat(d.SGST) || 0,
                    igst: parseFloat(d.IGST) || 0,
                    amount: amount,
                    TaxableAmt: Number(d.TaxableAmt) || 0,
                    Group: d.Group || "Ungrouped"
                };
            });

            // Additional Charges — bound directly from Adc1Amt..Adc5Amt on
            // master; the name for each slot comes from productmaster.description
            // where TransType = 199 + slot (200-204), via additionalChargeItems.
            const additionalCharges = [1, 2, 3, 4, 5]
                .map(slot => {
                    const chargeItem = (additionalChargeItems || []).find(ci => Number(ci.TransType) === 199 + slot);
                    return {
                        name: chargeItem?.description || `Charge ${slot}`,
                        amount: Number(master[`Adc${slot}Amt`]) || 0,
                    };
                })
                .filter(c => c.amount > 0);

            const orderData = {
                companyId,
                companyName: master.FirmName || "",
                address: master.Address || "",
                phone: master.MobileNo || "",
                gstNo: master.GSTNo || "",
                invoiceNo: master.SONumber || "",
                referrenceNo: master.PartyPONO || master.RefNo || "",
                date: master.SODate ? normalizeDate(master.SODate) : "",
                transport: master.Transporter || "SELF",
                challanNo: master.lrNumber || "",
                poNo: master.Project || "",
                state: master.state || "",
                stateCode: master.StateCode || "",
                LrNo: master.lrNumber || "",
                vehNo: master.vehicleNumber || "",
                LrDate: master.lrDate ? normalizeDate(master.lrDate) : "",
                shipToGstNumber: master.shipToGstNumber || "",
                shipToState: master.state || "",
                items,
                toEmail: master.EmailId || "",
                totalAmount: master.grandTotal || 0,
                mobileNo: master.MobileNo || "",
                basicAmount: Number(master.TaxableAmt) || 0,
                additionalCharges,
                CGSTAmt: Number(master.CGSTAmt) || 0,
                SGSTAmt: Number(master.SGSTAmt) || 0,
                IGSTAmt: Number(master.IGSTAmt) || 0,
                RoundOff: Number(master.RoundOff) || 0,
                BillAmt: Number(master.BillAmt) || 0,
                clientState: master.clientState || "",
                clientStateCode: master.clientStateCode || "",
                imageBase64: imageBase64 || null,
                Remark: master.Remark || null,
                termsAndConditions: termsText,
                PaymentTerm: master.PaymentTerm || null,
            };

            const companyHeader = companyDetails ? {
                CompId: companyDetails.CompId,
                CompanyName: companyDetails.CompanyName || "",
                Address: companyDetails.Address || "",
                MobileNo: companyDetails.MobileNo || "",
                EmailId: companyDetails.EmailId || "",
                Website: companyDetails.Website || "",
                GSTNo: companyDetails.GSTNo || "",
                imageBase64: imageBase64 || null,
                city: companyDetails.City || null,
                BkName1: companyDetails.BkName1 || null,
                BkBranch1: companyDetails.BkBranch1 || null,
                BkAcNo1: companyDetails.BkAcNo1 || null,
                BkIFSCCode1: companyDetails.BkIFSCCode1 || null,
                // ✅ NEW: Include Color from matchedFormat for PDF rendering
                headerColor: matchedFormat?.Color || '#000000',
            } : null;

            console.log(companyHeader)

            const pdfResp = await axios.post(
                `${PDF_API_BASE}/api/pdf/Order/${encodeURIComponent(soId)}`,
                {
                    docId: soId,
                    userId: userIdSafe,
                    formatId,
                    bookName: bookNameToSend,
                    ...(bookIdToSend !== null && { bookId: bookIdToSend }),
                    data: orderData,
                    company: { ...companyHeader, imageBase64: imageBase64 || null, signatureBase64: signatureBase64 || null }
                },
                { responseType: "blob", timeout: 180000 }
            );

            const blob = pdfResp.data;
            if (!blob || blob.size === 0) throw new Error("Empty PDF");

            const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

            // (old code : commented to implement pdf view in webview)
            // const newWin = window.open(blobUrl, "_blank");
            // if (newWin) {
            //     newWinRef.current = newWin;
            //     newWin.focus();
            //     const checker = setInterval(() => {
            //         if (newWin.closed) {
            //             URL.revokeObjectURL(blobUrl);
            //             clearInterval(checker);
            //         }
            //     }, 1000);
            // } else {
            //     if (pdfUri) URL.revokeObjectURL(pdfUri);
            //     setPdfUri(blobUrl);
            //     setSnackbarMessage("Popup blocked — showing PDF inline");
            //     setSnackbarSeverity("warning");
            //     setSnackbarOpen(true);
            // }


            // (new code : Added to handle pdf in web and mobile both using webview)
            if (window.ReactNativeWebView) {

                const reader = new FileReader();

                reader.onloadend = () => {
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                            type: "OPEN_PDF",
                            base64: reader.result
                        })
                    );
                };

                reader.readAsDataURL(blob);

            } else {

                const newWin = window.open(blobUrl, "_blank");
                if (newWin) {
                    newWinRef.current = newWin;
                    newWin.focus();
                    const checker = setInterval(() => {
                        if (newWin.closed) {
                            URL.revokeObjectURL(blobUrl);
                            clearInterval(checker);
                        }
                    }, 1000);
                } else {
                    if (pdfUri) URL.revokeObjectURL(pdfUri);
                    setPdfUri(blobUrl);
                    setSnackbarMessage("Popup blocked — showing PDF inline");
                    setSnackbarSeverity("warning");
                    setSnackbarOpen(true);
                }
            }
        } catch (err) {
            console.error("PDF Generation Failed:", err);
            setPdfError(err?.message || "Failed to generate PDF");
            setSnackbarMessage("Could not generate PDF.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setPdfOverlayVisible(false);
            setIsGeneratingPdf(false);
            setPdfLoading(false);
        }
    };

    // Filtered data
    const filteredOrders = useMemo(() => {
        if (!filterText) return orders;
        const lower = filterText.toLowerCase();
        return orders.filter(row =>
            String(row.SONumber || "").toLowerCase().includes(lower) ||
            String(row.PartyName || "").toLowerCase().includes(lower)
        );
    }, [orders, filterText]);

    const filteredQuotations = useMemo(() => {
        if (!filterText) return genQuoteData;
        const lower = filterText.toLowerCase();
        return genQuoteData.filter(row =>
            String(row.QoutNumber || "").toLowerCase().includes(lower) ||
            String(row.FirmName || "").toLowerCase().includes(lower)
        );
    }, [genQuoteData, filterText]);

    const handleSelectAllVisible = () => {
        const visibleIds = filteredOrders.map(r => r.SOId);
        const allSelected = visibleIds.every(id => selectionModel.includes(id));
        if (allSelected) {
            setSelectionModel(prev => prev.filter(id => !visibleIds.includes(id)));
        } else {
            setSelectionModel(prev => [...new Set([...prev, ...visibleIds])]);
        }
    };

    const allVisibleSelected = useMemo(() => {
        const visibleIds = filteredOrders.map(r => r.SOId);
        return visibleIds.length > 0 && visibleIds.every(id => selectionModel.includes(id));
    }, [filteredOrders, selectionModel]);

    // Mobile card renderers
    // Mobile card renderers
    const renderOrderCards = () => {
        if (loading) return <SkeletonLoader count={3} height={120} />;
        if (filteredOrders.length === 0) return <Typography sx={{ p: 4, textAlign: 'center' }}><CustomNoDataOverlay /></Typography>;

        return filteredOrders.map((row) => {
            const isSelected = selectionModel.includes(row.SOId);
            const avatarColor = stringToColor(row.PartyName || 'Order');
            const initials = getInitials(row.PartyName);
            const locationText = [row.City, row.state].filter(Boolean).join(', ') || '—';

            const toggleSelection = (e) => {
                e.stopPropagation();
                setSelectionModel(prev =>
                    prev.includes(row.SOId)
                        ? prev.filter(id => id !== row.SOId)
                        : [...prev, row.SOId]
                );
            };

            const hasReference = Boolean(row.PartyPONO);

            return (
                <Card
                    key={row.SOId}
                    onClick={() => navigate(`/main/v3/orderMaster-edit/${row.SOId}`)}
                    sx={{
                        mb: 2,
                        borderLeft: `6px solid ${hasReference ? '#FF9800' : '#1976d2'}`,
                        borderRadius: 2,
                        overflow: 'hidden',
                        boxShadow: 3,
                        bgcolor: 'background.paper',
                        cursor: 'pointer',
                        '&:hover': { boxShadow: 6 },
                    }}
                >
                    <CardContent sx={{ p: { xs: 1.5, sm: 2 }, py: 2 }}>
                        {/* Top Row */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                                {role !== 'User' && (
                                    <Checkbox
                                        checked={isSelected}
                                        onChange={toggleSelection}
                                        onClick={(e) => e.stopPropagation()}
                                        size="small"
                                    />
                                )}
                                <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36, flexShrink: 0 }}>
                                    {initials}
                                </Avatar>
                                <Box sx={{ ml: 1.5, flex: 1, minWidth: 0 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }} noWrap>
                                        {row.PartyName || '—'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" noWrap>
                                        {locationText}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, ml: 1 }} noWrap>
                                {normalizeDate(row.SODate)}
                            </Typography>
                        </Box>

                        {/* Order No. + Amount */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {row.SONumber || '—'}
                                </Typography>
                            </Box>
                            {role !== "SalesMan" && (
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                    ₹{Number(row.BillAmt || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                </Typography>
                            )}
                        </Box>

                        {/* Reference Chip */}
                        <Box sx={{ mb: 0.8 }}>
                            {hasReference ? (
                                <Chip
                                    label={`Ref: ${row.PartyPONO}`}
                                    size="small"
                                    sx={{
                                        bgcolor: '#FFF3E0',
                                        color: '#E65100',
                                        fontWeight: 500
                                    }}
                                />
                            ) : (
                                <Chip
                                    label="Manual"
                                    size="small"
                                    // color="primary"
                                    sx={{ bgcolor: '#e7f5ff', color: "#0067bb" }}
                                // variant="outlined"
                                />
                            )}
                        </Box>

                        {/* Bottom: Contact + PDF Button */}
                        <Divider />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <PersonIcon sx={{ fontSize: 18, color: '#FF9800', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {row.ContactPerson || '—'}
                                </Typography>
                            </Box>
                            <IconButton
                                color="primary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleView(row.SOId);
                                }}
                                sx={{ flexShrink: 0 }}
                            >
                                <PrintIcon />
                            </IconButton>
                        </Box>
                    </CardContent>
                </Card>
            );
        });
    };

    const renderQuotationCards = () => {
        if (loading) return <SkeletonLoader count={3} height={120} />;
        if (filteredQuotations.length === 0) return <Typography sx={{ p: 4, textAlign: 'center' }}><CustomNoDataOverlay /></Typography>;

        return filteredQuotations.map((row) => {
            const avatarColor = stringToColor(row.FirmName || 'Quotation');
            const initials = getInitials(row.FirmName);
            const locationText = [row.City, row.state].filter(Boolean).join(', ') || '—';

            return (
                <Card
                    key={row.QoutId}
                    onClick={() => navigate(`/main/v3/orderMaster-stepper-ref?quotationId=${row.QoutId}`)}
                    sx={{
                        mb: 2,
                        borderLeft: '6px solid #ff9800',
                        borderRadius: 2,
                        overflow: 'hidden',
                        boxShadow: 3,
                        bgcolor: 'background.paper',
                        cursor: 'pointer',
                        '&:hover': { boxShadow: 6 },
                    }}
                >
                    <CardContent sx={{ p: { xs: 1.5, sm: 2 }, py: 2 }}>
                        {/* Top Row */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                                <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36, flexShrink: 0 }}>
                                    {initials}
                                </Avatar>
                                <Box sx={{ ml: 1.5, flex: 1, minWidth: 0 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }} noWrap>
                                        {row.FirmName || '—'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" noWrap>
                                        {locationText}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, ml: 1 }} noWrap>
                                {normalizeDate(row.QoutDate)}
                            </Typography>
                        </Box>

                        {/* Quotation No. + Amount */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {row.QoutNumber || '—'}
                                </Typography>
                            </Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                ₹{Number(row.BillAmt || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                            </Typography>
                        </Box>

                        {/* Contact */}
                        <Divider sx={{ my: 1.5 }} />
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <PersonIcon sx={{ fontSize: 18, color: '#FF9800', mr: 1, flexShrink: 0 }} />
                            <Typography variant="body2" color="text.secondary" noWrap>
                                {row.ContactPerson || '—'}
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>
            );
        });
    };

    const handleSnackbarClose = () => setSnackbarOpen(false);

    const openFilterPopup = useCallback(() => {
        const { from, to } = getFinancialYearRange(new Date());
        const fromDate = filterPopupFromDate || from;
        const toDate = filterPopupToDate || to;
        if (!filterPopupFromDate) setFilterPopupFromDate(fromDate);
        if (!filterPopupToDate) setFilterPopupToDate(toDate);
        setFilterPopupSnapshot({ mode: filterPopupMode, fromDate, toDate, firms: filterPopupFirms });
        setFilterPopupOpen(true);
    }, [filterPopupFromDate, filterPopupToDate, filterPopupMode, filterPopupFirms]);

    const cancelFilterPopup = useCallback(() => {
        if (filterPopupSnapshot) {
            setFilterPopupMode(filterPopupSnapshot.mode);
            setFilterPopupFromDate(filterPopupSnapshot.fromDate);
            setFilterPopupToDate(filterPopupSnapshot.toDate);
            setFilterPopupFirms(filterPopupSnapshot.firms || []);
        }
        setFilterPopupOpen(false);
    }, [filterPopupSnapshot]);

    const handleFilterOk = useCallback(async () => {
        setExportExcelEnabled(true);

        if (!companyId) {
            setSnackbar({
                open: true,
                message: 'Company not selected',
                severity: 'warning'
            });
            return;
        }

        if (!filterPopupFromDate || !filterPopupToDate) {
            setSnackbar({
                open: true,
                message: 'Please select date range',
                severity: 'warning'
            });
            return;
        }

        setReportLoading(true);

        try {
            const filterParams = {
                companyId,
                fromDate: filterPopupFromDate,
                toDate: filterPopupToDate,
                mode: filterPopupMode,
                firms: filterPopupFirms.length > 0
                    ? filterPopupFirms.map(f => f.id).join(',')
                    : '',
            };

            const response = await axios.get(
                `${api}/api/sale-order-register`,
                { params: filterParams }
            );

            const masterData = response?.data?.master?.data || [];
            const detailsData = response?.data?.details?.data || [];

            setMasterReportData(masterData);
            setDetailsReportData(detailsData);

            setSnackbar({
                open: true,
                message: `Report loaded: ${masterData.length} master records, ${detailsData.length} detail records`,
                severity: 'success'
            });

            console.log('Master Report Data:', masterData);
            console.log('Details Report Data:', detailsData);

        } catch (err) {
            console.error('Error fetching report data:', err);
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || 'Failed to fetch report data',
                severity: 'error'
            });
        } finally {
            setReportLoading(false);
        }
    }, [
        companyId,
        filterPopupFromDate,
        filterPopupToDate,
        filterPopupMode,
        filterPopupFirms,
        api
    ]);

    const handleExportExcel = useCallback(() => {
        if (!masterReportData.length && !detailsReportData.length) {
            setSnackbar({ open: true, message: 'No data to export. Please apply filters first.', severity: 'warning' });
            return;
        }

        const formatDate = (val) => {
            if (!val) return '';
            const s = String(val).split('T')[0];
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                const [y, m, d] = s.split('-');
                return `${d}-${m}-${y}`;
            }
            return val;
        };

        const buildSheet = (data, columns) => {
            const header = columns.map(c => c.header);
            const rows = data.map(row =>
                columns.map(c => {
                    const val = row[c.key] ?? '';
                    if (c.isDate) return formatDate(val);
                    if (val === 0 || val === '0' || val === 0.0) return '';
                    // Numeric columns often arrive from the API as strings (e.g. SQL
                    // DECIMAL fields serialized as text). aoa_to_sheet writes cells
                    // based on the JS value's type, so a string here becomes a text
                    // cell that Excel's status bar (Sum/Average) will not aggregate.
                    // Coerce to a real number so these columns total correctly.
                    if (c.isNumeric) {
                        const num = Number(val);
                        return Number.isNaN(num) ? val : num;
                    }
                    return val;
                })
            );
            return XLSX.utils.aoa_to_sheet([header, ...rows]);
        };

        const masterColumns = [
            { key: 'SODate', header: 'BillDate', isDate: true },
            { key: 'SONumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'GSTCEssAmt', header: 'GSTCessAmt', isNumeric: true },
            { key: 'BillAmt', header: 'BillAmt', isNumeric: true },
            { key: 'Remark', header: 'Remark' },
        ];

        const detailsColumns = [
            { key: 'SODate', header: 'BillDate', isDate: true },
            { key: 'SONumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'itemCode', header: 'ItemCode' },
            { key: 'description', header: 'Description' },
            { key: 'HSNNo', header: 'HSNNo' },
            { key: 'Unit', header: 'Unit' },
            { key: 'Qty', header: 'Qty', isNumeric: true },
            { key: 'Rate', header: 'Rate', isNumeric: true },
            { key: 'Disc', header: 'Disc', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'CGSTRate', header: 'CGSTRate', isNumeric: true },
            { key: 'SGSTRate', header: 'SGSTRate', isNumeric: true },
            { key: 'IGSTRate', header: 'IGSTRate', isNumeric: true },
            { key: 'CESSRate', header: 'CESSRate', isNumeric: true },
            { key: 'UTGSTRate', header: 'UTGSTRate', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'CESSAmt', header: 'CESSAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'ItemRemark', header: 'ItemRemark' },
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, buildSheet(masterReportData, masterColumns), 'Master');
        XLSX.utils.book_append_sheet(wb, buildSheet(detailsReportData, detailsColumns), 'Details');

        const fromDate = filterPopupFromDate || 'start';
        const toDate = filterPopupToDate || 'end';
        XLSX.writeFile(wb, `OrderRegister_${fromDate}_${toDate}.xlsx`);

        setSnackbar({ open: true, message: 'Excel exported successfully!', severity: 'success' });
    }, [masterReportData, detailsReportData, filterPopupFromDate, filterPopupToDate]);

    useEffect(() => {
        if (!filterPopupOpen) return;
        if (!api || !companyId) return;
        let active = true;
        const fetchAllFirms = async () => {
            try {
                setFirmLoading(true);
                const res = await axios.get(`${api}/api/company-search`, { params: { field: 'FirmName', search: '', companyId, limit: 1000 } });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                if (!active) return;
                const opts = data.map(r => ({ id: r?.id, label: r?.FirmName || '' })).filter(o => o.label);
                setFirmAllOptions(opts);
                if (!(firmInputValue || '').trim()) setFirmOptions(opts);
            } catch (err) {
                if (!active) return;
                setFirmAllOptions([]);
                setFirmOptions([]);
            } finally {
                if (active) setFirmLoading(false);
            }
        };
        fetchAllFirms();
        return () => { active = false; };
    }, [companyId, api, filterPopupOpen]);

    useEffect(() => {
        if (!filterPopupOpen) return;
        if (!api || !companyId) return;
        const q = (firmInputValue || '').trim();
        if (!q) { setFirmOptions(firmAllOptions); return; }
        let active = true;
        const t = setTimeout(async () => {
            try {
                setFirmLoading(true);
                const res = await axios.get(`${api}/api/company-search`, { params: { field: 'FirmName', search: q, companyId } });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                if (!active) return;
                setFirmOptions(data.map(r => ({ id: r?.id, label: r?.FirmName || '' })).filter(o => o.label));
            } catch (err) {
                if (active) setFirmOptions([]);
            } finally {
                if (active) setFirmLoading(false);
            }
        }, 350);
        return () => { active = false; clearTimeout(t); };
    }, [companyId, api, filterPopupOpen, firmAllOptions, firmInputValue]);

    return (
        <Box sx={{
            pt: 0.7, px: { xs: 2, sm: 3, md: 4 }, display: 'flex',
            flexDirection: 'column',
            height: (activeCard === "get" && isDesktop)
                ? `calc(185vh - ${APPBAR_HEIGHT}px)`
                : `calc(100vh - ${APPBAR_HEIGHT}px)`,
        }}>
            {/* ── Module Header ──────────────────────────────────────────── */}
            <Box sx={{ mb: 1.5 }}>
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)', borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Sale Orders
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button variant="outlined" size="small" startIcon={<FilterAltIcon />} onClick={openFilterPopup}>Filter</Button>
                        {/* Toggle linked quotations panel */}
                        <Button variant="contained" size="small" onClick={handleToggleQuotations}>{activeCard === "get" ? "Hide" : "Show"} Quotation</Button>
                        <Button variant="contained" size="small" startIcon={<AddIcon />} component={Link} to="/main/v3/orderMaster-stepper">
                            {isSmallDevice ? 'Add' : 'Add Sale Order'}
                        </Button>
                    </Box>
                </Paper>
            </Box>

            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, marginBottom: "12px" }}>
                <Box sx={{
                    p: { xs: 0.5, md: 0.5 },
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    minHeight: 0,
                }}
                >
                    {/* Search on mobile */}
                    {!isDesktop && (
                        <Box sx={{ mb: 1.5, px: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder={activeCard === "get" ? "Search Quotation No..." : "Search Order No..."}
                                value={filterText}
                                onChange={(e) => setFilterText(e.target.value)}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                                }}
                                variant="outlined"
                            />
                        </Box>
                    )}

                    {/* Bulk delete bar on mobile (only for orders) */}
                    {!isDesktop && role !== 'User' && activeCard !== "get" && selectionModel.length > 0 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 1.5, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox checked={allVisibleSelected} onChange={handleSelectAllVisible} size="small" />
                                <Typography variant="body2" sx={{ ml: 1 }}>{selectionModel.length} selected</Typography>
                            </Box>
                            <Tooltip title="Delete selected">
                                <IconButton onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete();
                                }} color="error"><DeleteIcon /></IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    {/* Desktop: DataGrid(s) */}
                    {isDesktop ? (
                        <>
                            {activeCard === "get" && (
                                <Paper elevation={2} sx={{ borderRadius: 3, p: 1.5, overflow: 'hidden', mb: 3, flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                        <Typography variant="h6" fontWeight={600}>Quotation List</Typography>
                                    </Box>
                                    <Box sx={{ flex: 1, width: '100%', minHeight: 0, display: "flex", position: 'relative' }}>
                                        <LoadingOverlay isVisible={loading} />
                                        {!loading && genQuoteData?.length === 0 && <NoDataComponent />}
                                        {!loading && genQuoteData?.length > 0 && (
                                            <DataGrid
                                                getRowHeight={() => 'auto'}
                                                rows={genQuoteData}
                                                columns={quotationColumns}
                                                getRowId={(row) => row.QoutId}
                                                pageSizeOptions={[50, 100]}
                                                pagination
                                                disableSelectionOnClick
                                                disableRowSelectionOnClick
                                                slots={{
                                                    noRowsOverlay: () => (
                                                        <Box sx={{ p: 2, textAlign: 'center' }}>
                                                            <Typography>No quotation records found.</Typography>

                                                        </Box>
                                                    ),
                                                    noResultsOverlay: CustomNoDataOverlay
                                                }}
                                                sx={{
                                                    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
                                                    '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                                    '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },

                                                    // Background styling
                                                    '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                                                    '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

                                                    // Row styling
                                                    '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
                                                    '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
                                                    '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

                                                    // Selected row styling (with !important to override default MUI)
                                                    '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },

                                                    // Cell content alignment
                                                    '& .MuiDataGrid-cell': {
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    },
                                                    flex: 1,
                                                }}

                                            />
                                        )}
                                    </Box>
                                </Paper>
                            )}
                            <Paper elevation={2} sx={{ borderRadius: 3, p: 1.5, overflow: 'hidden', flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                    <Typography variant="h6" fontWeight={600}>Order List</Typography>
                                </Box>
                                <Box sx={{ flex: 1, width: '100%', minHeight: 0, display: "flex", position: 'relative' }}>
                                    <LoadingOverlay isVisible={loading} />
                                    {!loading && orders?.length === 0 && <NoDataComponent />}
                                    {!loading && orders?.length > 0 && (
                                        <DataGrid
                                            getRowHeight={() => 'auto'}
                                            rows={orders}
                                            columns={orderColumns}
                                            getRowId={(row) => row.SOId}
                                            pageSizeOptions={[50, 100]}
                                            checkboxSelection={role !== "User"}
                                            rowSelectionModel={selectionModel}
                                            onRowSelectionModelChange={(newSel) => setSelectionModel(newSel.map(Number))}
                                            disableRowSelectionOnClick
                                            slots={{
                                                noRowsOverlay: () => (
                                                    <Box sx={{ p: 2, textAlign: 'center' }}>
                                                        <Typography>No quotation records found.</Typography>

                                                    </Box>
                                                ),
                                                noResultsOverlay: CustomNoDataOverlay
                                            }}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
                                                '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                                '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },

                                                // Background styling
                                                '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                                                '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

                                                // Row styling
                                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
                                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
                                                '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

                                                // Selected row styling (with !important to override default MUI)
                                                '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },

                                                // Cell content alignment
                                                '& .MuiDataGrid-cell': {
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                },
                                                flex: 1
                                            }}
                                        />
                                    )}
                                </Box>
                            </Paper>
                        </>
                    ) : <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflowY: 'auto',
                            px: "12px"
                        }}
                    >
                        {/* EVERYTHING BELOW SEARCH GOES HERE */}

                        {activeCard === "get" ? (
                            <>
                                <Box sx={{ mb: 1.5 }}>
                                    <Typography variant="h6">Quotation List</Typography>
                                </Box>

                                {genQuoteData?.length === 0
                                    ? <NoDataComponent />
                                    : renderQuotationCards()}
                            </>
                        ) : (
                            <>
                                <Box sx={{ mb: 1.5 }}>
                                    <Typography variant="h6">Order List</Typography>
                                </Box>

                                {orders?.length === 0
                                    ? <NoDataComponent />
                                    : renderOrderCards()}
                            </>
                        )}
                    </Box>}
                </Box>
            </Paper>

            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert severity={snackbarSeverity} variant="filled">{snackbarMessage}</Alert>
            </Snackbar>

            {pdfError && <Box sx={{ mt: 2 }}><Alert severity="error">PDF Error: {pdfError}</Alert></Box>}
            {pdfLoading && <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}><CircularProgress size={18} /> <Typography>Preparing PDF...</Typography></Box>}
            {pdfUri && <Box sx={{ mt: 2 }}><PdfViewer uri={pdfUri} remoteFallbackUrl={pdfApiUrl} /></Box>}

            {pdfOverlayVisible && (
                <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.92)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, backdropFilter: "blur(4px)" }}>
                    <Box sx={{ textAlign: "center", backgroundColor: "#111", padding: "40px 60px", borderRadius: "20px", boxShadow: "0 20px 40px rgba(0,0,0,0.6)" }}>
                        <CircularProgress size={60} thickness={4} sx={{ color: "#fff" }} />
                        <Typography variant="h6" sx={{ color: "#fff", mt: 3, fontWeight: 600 }}>Generating Order PDF…</Typography>
                        <Typography variant="body2" sx={{ color: "#aaa", mt: 1 }}>Please wait</Typography>
                    </Box>
                </Box>
            )}

            {/* ── Delete Confirmation Dialog ──────────────────────────── */}
            <Dialog open={openDeleteDialog} onClose={() => { if (!deleting) setOpenDeleteDialog(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)' }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>Confirm Deletion</Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">{selectionModel.length}</Typography>
                        {' '}sale order(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setOpenDeleteDialog(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button onClick={confirmDelete} color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

            {/* Filter Popup */}
            <Dialog
                open={filterPopupOpen}
                onClose={cancelFilterPopup}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1.5,
                        pt: 2,
                        px: 3,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                p: 0.8,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <FilterListIcon sx={{ color: 'white', fontSize: 20 }} />
                        </Box>
                        <Typography variant="h6" fontWeight={600} sx={{ fontSize: '1.1rem' }}>
                            Filter Orders
                        </Typography>
                    </Box>

                    <IconButton
                        onClick={cancelFilterPopup}
                        size="small"
                        sx={{
                            color: 'white',
                            bgcolor: 'rgba(255,255,255,0.15)',
                            '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' }
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 3, py: 2, bgcolor: '#fafafa' }}>
                    {/* Filter Mode Selection */}
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            mb: 1,
                            mt: 1,
                            bgcolor: 'white',
                            border: '1px solid #e0e0e0',
                            borderRadius: 2,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1 }} />
                            <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'text.primary' }}>
                                Filter Mode
                            </Typography>
                        </Box>

                        <RadioGroup
                            row
                            value={filterPopupMode}
                            onChange={(e) => setFilterPopupMode(e.target.value)}
                            sx={{ display: 'flex', gap: 2 }}
                        >
                            <FormControlLabel
                                value="datewise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{ '&.Mui-checked': { color: 'primary.main' } }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            📅 Datewise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'datewise' ? '#e3f2fd' : '#f5f5f5',
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'datewise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'datewise' ? '#e3f2fd' : '#eeeeee',
                                    }
                                }}
                            />

                            <FormControlLabel
                                value="partywise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{ '&.Mui-checked': { color: 'primary.main' } }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            👥 Partywise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'partywise' ? '#e3f2fd' : '#f5f5f5',
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'partywise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'partywise' ? '#e3f2fd' : '#eeeeee',
                                    }
                                }}
                            />
                        </RadioGroup>
                    </Paper>

                    {/* Filter Fields */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {/* Date Range */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#ff6b6b', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    📆 Date Range
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        From Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupFromDate}
                                        onChange={(e) => setFilterPopupFromDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: '#f8f9fa',
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: '#e9ecef' },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#dee2e6' }
                                        }}
                                    />
                                </Box>

                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        To Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupToDate}
                                        onChange={(e) => setFilterPopupToDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: '#f8f9fa',
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: '#e9ecef' },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#dee2e6' }
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Paper>

                        {/* FirmName */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#4ecdc4', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    🏢 FirmName
                                </Typography>
                            </Box>

                            <Autocomplete
                                multiple
                                disableCloseOnSelect
                                options={firmOptions}
                                loading={firmLoading}
                                value={filterPopupFirms}
                                onChange={(_, newValue) => setFilterPopupFirms(newValue)}
                                inputValue={firmInputValue}
                                onInputChange={(_, v) => setFirmInputValue(v)}
                                getOptionLabel={(o) => o?.label || ''}
                                isOptionEqualToValue={(o, v) =>
                                    String(o?.id ?? o?.label) === String(v?.id ?? v?.label)
                                }
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            size="small"
                                            sx={{
                                                mr: 1,
                                                color: '#4ecdc4',
                                                '&.Mui-checked': { color: '#4ecdc4' }
                                            }}
                                        />
                                        <Typography variant="body2">{option?.label || ''}</Typography>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        placeholder={
                                            filterPopupFirms?.length
                                                ? `${filterPopupFirms.length} firm(s) selected`
                                                : 'Select firms (ALL)'
                                        }
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: '#f8f9fa',
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: '#e9ecef' },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#dee2e6' }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    {filterPopupFirms?.length > 0 && (
                                                        <Chip
                                                            label={`${filterPopupFirms.length}`}
                                                            size="small"
                                                            sx={{
                                                                ml: 0.5,
                                                                height: 22,
                                                                bgcolor: '#4ecdc4',
                                                                color: 'white',
                                                                fontWeight: 700,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                ListboxProps={{ style: { maxHeight: 200 } }}
                            />
                        </Paper>
                    </Box>
                </DialogContent>

                {/* Action Buttons */}
                <DialogActions
                    sx={{
                        px: 3,
                        py: 1.5,
                        bgcolor: '#fafafa',
                        borderTop: '1px solid #e0e0e0',
                        gap: 2
                    }}
                >
                    <Button
                        onClick={cancelFilterPopup}
                        variant="outlined"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            borderColor: '#d0d0d0',
                            color: 'text.secondary',
                            '&:hover': { borderColor: '#999', bgcolor: '#f5f5f5' }
                        }}
                    >
                        ✕ Cancel
                    </Button>

                    {/* Export Excel Button */}
                    <Button
                        onClick={handleExportExcel}
                        variant="outlined"
                        disabled={!exportExcelEnabled}
                        sx={{
                            flex: 1, borderRadius: 2, textTransform: 'none', fontWeight: 600, py: 1.2,
                            borderColor: !exportExcelEnabled ? '#d0d0d0' : '#2e7d32',
                            color: !exportExcelEnabled ? 'text.disabled' : '#2e7d32',
                            '&:hover': {
                                borderColor: '#2e7d32',
                                bgcolor: '#f1f8e9'
                            },
                            '&.Mui-disabled': {
                                borderColor: '#d0d0d0',
                                color: 'text.disabled'
                            }
                        }}
                    >
                        📊 Export Excel
                    </Button>

                    <Button
                        onClick={handleFilterOk}
                        variant="contained"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)',
                                boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)'
                            }
                        }}
                    >
                        ✓ Apply Filters
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default OrderDetail;